<template>
  <div>
    <!-- 通栏video -->
    <div class="video-banner-m">
      <video :src="videoBanner.src" loop autoplay muted :poster="videoBanner.cover"></video>
      <div class="links">
        <a :href="item.link" v-for="(item, index) in videoBanner.buttons" :key="index" target="_block">{{ item.name }}</a>
      </div>
    </div>
    <!-- 轮播 -->
    <div :class="isMobile ? 'swipe-banner-m' : 'swipe-banner'">
      <div class="title">
        <a target="_blank" :href="swipeBanner[currentIndex].link">{{ swipeBanner[currentIndex].title }}</a>
      </div>
      <van-swipe ref="swipe" class="swipe" indicator-color="white" @change="onChange">
        <van-swipe-item v-for="(item, index) in swipeBanner" :key="index">
          <div class="abstract">{{ item.content }}</div>
          <div class="buts" @click="swipeButs($event, item)">
            <div class="listen" :class="audioPlay ? 'pause' : 'play'">LISTEN</div>
            <div class="share">SHARE</div>
          </div>
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator" @click="swipeTo">
            <span :class="{'active': item === currentIndex + 1}" v-for="item in swipeBanner.length" :key="item" :data-index="item"></span>
          </div>
        </template>
      </van-swipe>
    </div>
    <!-- 文字列表 -->
    <div :class="isMobile ? 'text-banner-m' : 'text-banner' ">
      <div class="items">
        <div class="item" v-for="(item, index) in swipeBanner" :key="index">
          <a target="_block" :href="item.link">{{ item.title }}</a>
        </div>
      </div>
    </div>
    <!-- 视频列表(big) -->
    <div :class="isMobile ? 'video-big-list-banner-m' : 'video-big-list-banner'" v-for="(item, index) in reverseBigVideoList" :key="index">
      <img :src="item.bg">
      <div class="block">
        <div class="cover">
          <img :src="item.cover" :alt="item.cover">
          <i class="play" v-if="item.videoSrc" @click="videoPlay(item)"></i>
        </div>
        <div class="info">
          <a :href="item.link" target="_block" class="title">{{ item.title }}</a>
          <div class="abstract">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <!-- 视频列表(small) -->
    <div v-if="false" :class="isMobile ? 'video-small-list-banner-m' : 'video-small-list-banner'" v-for="block in smallVideoList" :key="block.bg">
      <img :src="block.bg">
      <div class="block">
        <div class="item" v-for="item in block.list" :key="item.title">
          <div class="cover">
            <img :src="item.cover">
            <i class="play" v-if="item.videoSrc" @click="videoPlay(item)"></i>
          </div>
          <a class="title" :href="item.link" target="_block">{{ item.title }}</a>
        </div>
      </div>
    </div>

    <!-- 视频弹框 -->
    <van-popup v-model="show" closeable get-container="body">
      <video :src="currentvideoSrc" :poster="currentvideoCoverSrc" autoplay controls :class="isMobile ? 'dialog-video-m' : 'dialog-video'" v-if="show"></video>
    </van-popup>

    <!-- 分享弹框 -->
    <van-popup v-model="shareShow" closeable @close="qrcodeShow = false">
      <p class="share-title">
        <span v-if="copyShow" style="position: absolute; left: 10px;">Copié</span>
        <span>Share</span>
      </p>
      <div class="share" @click="share">
        <img src="@/assets/shareIcon/facebook@3x.png" data-id="facebook">
        <img src="@/assets/shareIcon/share-vk.png" data-id="vk">
        <img src="@/assets/shareIcon/twitter@3x.png" data-id="twitter">
        <img src="@/assets/shareIcon/wechat@3x.png" data-id="wechat">
        <img src="@/assets/shareIcon/share-weibo2.png" data-id="weibo">
        <img src="@/assets/shareIcon/mail@3x.png" data-id="mail">
        <img src="@/assets/shareIcon/copy@3x.png" data-id="copy">
      </div>
    </van-popup>

    <div class="qrcode" v-if="qrcodeShow">
      <div class="x" @click="qrcodeShow = false">x</div>
      <img :src="shareQr">
    </div>

    <!-- 音频播放器 -->
    <audio :src="currentAudioSrc" v-show="false" ref="audio"></audio>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Popup } from 'vant'
import { videoBanner, swipeBanner, bigVideoList, smallVideoList } from './data.js'
import VueQrcode from 'vue-qrcode';
import QRCode from 'qrcode';
export default {
  name: '',
  components: {
    ['van-swipe']: Swipe,
    ['van-swipe-item']: SwipeItem,
    ['van-popup']: Popup,
    ['vue-qrcode']: VueQrcode
  },
  data () {
    return {
      videoBanner,
      swipeBanner,
      bigVideoList,
      smallVideoList,
      currentIndex: 0,
      currentAudioSrc: '',
      currentvideoSrc: '',
      currentvideoCoverSrc: '',
      show: false,
      shareShow: false,
      shareItem: {},
      shareQr: 'data:image/png;base64,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',
      copyShow: false,
      copyShowTime: 0,
      audioPlay: false,
      qrcodeShow: false
    }
  },
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    reverseBigVideoList () {
      return this.bigVideoList.reverse()
    }
  },
  watch: {
    copyShow (val) {
      if (val) {
        this.copyShowTime = setTimeout(() => {
          this.copyShow = false
          clearTimeout(this.copyShowTime)
        }, 1000)
      }
    }
  },
  methods: {
    onChange (index) {
      this.currentIndex = index
      this.currentAudioSrc = ''
      this.audioPlay = false
    },
    swipeTo (e) {
      const index = e.target.getAttribute('data-index') - 1
      if (index >= 0) {
        this.$refs.swipe.swipeTo(index)
      }
    },
    videoPlay (item) {
      this.currentAudioSrc = ''
      this.audioPlay = false
      this.currentvideoSrc = item.videoSrc
      this.currentvideoCoverSrc = item.cover
      this.show = true
    },
    swipeButs (e, item) {
      const type = e.target.innerText
      const src = item.radioUrl
      switch (type) {
        case 'LISTEN':
          this.currentAudioSrc = src
          this.$nextTick(() => {
            const audio =  this.$refs.audio
            if (!audio.paused) {
              audio.pause()
            } else {
              audio.play()
            }
            this.audioPlay = !audio.paused
          })
          break;
        case 'SHARE':
          this.shareItem = item
          this.shareShow = true
          break;
      }
    },
    share (e) {
      const type = e.target.getAttribute('data-id')
      const url = this.shareItem.link
      const title = this.shareItem.title
      let link = ''
      switch (type) {
        case 'facebook':
          link = `https://www.facebook.com/sharer/sharer.php?u=${url}&display=popup&app_id=632378397093617` 
          break;
        case 'vk':
          link = `https://vk.com/share.php?url=${url}&title=${title}`
          break;
        case 'wechat':
          QRCode.toDataURL(url, {
            errorCorrectionLevel: 'L',
            margin: 1,
            height: 200,
            width: 200,
            scal: 177,
            color: {
              dark: '#000'
            }
          }).then(base64 => {
            this.shareQr = base64
            this.qrcodeShow = true
          })
          break;
        case 'copy':
          this.$copyText(url).then(() => {
            this.copyShow = true
          })
          break;
        case 'mail':
          const body = encodeURIComponent('Cela peut vous intéresser ! ' + url)
          link = `mailto:?subject=${title}&body=${body}`
          break;
        case 'twitter':
          link = `https://twitter.com/intent/tweet?text=${title}&url=${url}&via=CGTNFrancais`
          break;
        case 'weibo':
          link = `http://service.weibo.com/share/share.php?appkey=274269775&title=${title}&url=${url}&pic=&searchPic=true&style=simple`
          break;
      }
      if (link) {
        window.open(link)
      }
    }
  },

  mounted () {
  }
}
</script>

<style lang='less' scoped>
.video-banner{
  width: 100%;
  position: relative;
  video{
    width: 100%;
  }
  .links{
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    a {
      padding: 1vw 2vw;
      background: url('@/assets/img/btnBg.png') no-repeat;
      background-size: 100% 100%;
      color: #fff;
    }
  }
}
.swipe-banner{
  width: 100%;
  margin-top: 20px;
  .title{
    max-width: 90vw;
    text-align: center;
    margin: auto;
    &::before{
      content: '';
      display: inline-block;
      width: 2.5vw;
      height: 1.8vw;
      background: url('@/assets/img/icon-title-left.png');
      background-size: cover;
      margin-right: 1vw;
    }
    &::after{
      content: '';
      display: inline-block;
      width: 2.5vw;
      height: 1.8vw;
      background: url('@/assets/img/icon-title-right.png');
      background-size: cover;
      margin-left: 1vw;
    }
    a{
      font-size: 2.3vw;
      font-weight: bold;
      text-decoration: underline;
      font-family: Georgia-Bold;
      color: #333;
      display: inline-block;
      max-width: 70vw;
      margin: auto;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: bottom;
    }
  }
  .swipe{
    width: 100%;
    min-height: 300px;
    background-color: #39a9ed;
    background: url('@/assets/img/slide-bg.jpg');
    background-size: cover;
    margin-top: 2vw;
    position: relative;
    .van-swipe-item{
      display: flex;
      justify-content: center;
      color: #fff;
      padding-top: 50px;
      padding-bottom: 150px;
      .abstract{
        width: 800px;
        min-height: 260px;
        font: 400 1vw/1.4vw HelveticaNeueLTPro-Roman;
        background: url('@/assets/img/m-slide-summary-bg.png');
        background-size: cover;
        border-radius: 10px;
        border: 1px solid #fff;
        padding: 2vw;
      }
      .buts{
        margin-left: 20px;
        div{
          background: url('@/assets/img/m-slide-summary-bg.png');
          background-size: cover;
          border-radius: 10px;
          padding: 5px 50px 5px 10px;
          border: 1px solid #fff;
          margin: 10px;
          &.listen.play::before{
            content: '';
            display: inline-block;
            width: 1.5vw;
            height: 1.5vw;
            background: url('@/assets/img/slide-btn-play.png');
            background-size: cover;
            margin-right: 10px;
            vertical-align: bottom;
          }
          &.listen.pause::before{
            content: '';
            display: inline-block;
            width: 1.5vw;
            height: 1.5vw;
            background: url('@/assets/img/slide-btn-pause.png');
            background-size: cover;
            margin-right: 10px;
            vertical-align: bottom;
          }
          &.share::before{
            content: '';
            display: inline-block;
            width: 1.5vw;
            height: 1.5vw;
            background: url('@/assets/img/slide-btn-share.png');
            background-size: cover;
            margin-right: 10px;
            vertical-align: bottom;
          }
        }
      }
    }
    .custom-indicator{
      color: #fff;
      position: absolute;
      bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
      span{
        display: inline-block;
        width: 0.8vw;
        height: 0.8vw;
        border: 1px solid #fff;
        border-radius: 50%;
        cursor: pointer;
        margin-left: 10px;
      }
      .active{
        background: #fff;
      }
    }
  }
}
.text-banner{
  width: 100%;
  background: url('@/assets/img/boke-bg.jpg');
  background-size: cover;
  padding: 50px 0;
  .items{
    width: 80vw;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 1vw 2vw;
    .item{
      flex-shrink: 0;
      width: 15vw;
      padding: 1.2vw 5vw;
      background: url('@/assets/img/boke-item-bg.png') no-repeat;
      background-size: cover;
      box-sizing: content-box;
      a{
        text-decoration: underline;
        font: 600 1.2vw/1.875vw Georgia-Bold;
        color: #333;
      }
    }
  }
}
.video-big-list-banner{
  width: 100%;
  height: 530px;
  position: relative;
  & > img{
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    inset: 0;
  }
  .block{
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .cover{
      flex-shrink: 0;
      width: 38vw;
      min-height: 20vw;
      position: relative;
      .play{
        display: inline-block;
        width: 6.5vw;
        height: 6.5vw;
        background: url('@/assets/img/icon-sh-play.png');
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        left: 10px;
        cursor: pointer;
      }
    }
    .info{
      width: 38vw;
      margin-left: 50px;
      .title{
        display: -webkit-box;
        font: 600 2vw/40px Georgia-Bold;
        color: #fff;
        text-decoration: underline;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        vertical-align: bottom;
      }
      .abstract{
        color: #313030;
        font: 400 1vw/1.4vw HelveticaNeueLTPro-Roman;
        margin-top: 2.6vw;
      }
    }
  }
}
.video-small-list-banner{
  width: 100%;
  height: 260px;
  position: relative;
  & > img{
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    inset: 0;
  }
  .block{
    width: 80%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    position: absolute;
    inset: 0;
    z-index: 1;
    .item{
      width: 240px;
      margin-top: 35px;
      .cover{
        position: relative;
        & > img{
          width: 100%;
          display: block;
        }
        .play{
          display: inline-block;
          width: 4vw;
          height: 4vw;
          background: url('@/assets/img/icon-sh-play.png');
          background-size: 100% 100%;
          position: absolute;
          bottom: 1vw;
          left: 1vw;
          cursor: pointer;
        }
      }
      .title{
        display: -webkit-box;
        font: 600 12px/18px Georgia-Bold;
        color: #fff;
        text-decoration: underline;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        vertical-align: bottom;
        padding: 0 10px;
      }
    }
  }
}

.video-banner-m{
  width: 100%;
  position: relative;
  video{
    width: 100%;
  }
  .links{
    position: absolute;
    bottom: 170px;
    left: 50%;
    transform: translateX(-50%);
    a {
      padding: 1vw 2vw;
      color: #fff;
      text-decoration: underline;
    }
  }
}
.swipe-banner-m{
  width: 100%;
  position: relative;
  .title{
    width: 90%;
    margin: 0 auto;
    position: absolute;
    top: 130px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    display: flex;
    justify-content: center;
    text-align: center;
    &::before{
      content: '';
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url('@/assets/img/icon-m-slide-title-left.png');
      background-size: 100% 100%;
      margin-right: 10px;
      vertical-align: top;
    }
    &::after{
      content: '';
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url('@/assets/img/icon-m-slide-title-right.png');
      background-size: 100% 100%;
      margin-left: 10px;
      vertical-align: top;
    }
    a{
      display: block;
      font-size: 15px;
      text-decoration: underline;
      color: #fff;
      span{
        display: inline-block;
        width: 70vw;
        margin: auto;
      }
    }
  }
  .swipe{
    width: 100%;
    background-color: #39a9ed;
    background: url('@/assets/img/m-slide-bg.jpg');
    background-size: cover;
    position: relative;
    .van-swipe-item{
      color: #fff;
      padding-top: 50px;
      padding-bottom: 10px;
      margin-top: 150px;
      .abstract{
        width: 90vw;
        margin: auto;
        max-height: 260px;
        font: 400 12px/18px HelveticaNeueLTPro-Roman;
        background: url('@/assets/img/m-slide-summary-bg.png');
        background-size: cover;
        border-radius: 10px;
        border: 1px solid #fff;
        padding: 15px;
      }
      .buts{
        margin-left: 20px;
        div{
          display: inline-block;
          background: url('@/assets/img/m-slide-summary-bg.png');
          background-size: cover;
          border-radius: 10px;
          padding: 2px 30px 2px 10px;
          border: 1px solid #fff;
          margin: 10px;
          font-size: 11px;
          &::before{
            content: '';
            display: inline-block;
            width: 18px;
            height: 20px;
            margin-right: 10px;
            vertical-align: middle;
          }
          &.listen.play::before{
            background: url('@/assets/img/slide-btn-play.png');
            background-size: 100% 100%;
          }
          &.listen.pause::before{
            background: url('@/assets/img/slide-btn-pause.png');
            background-size: 100% 100%;
          }
          &.share::before{
            background: url('@/assets/img/slide-btn-share.png');
            background-size: 100% 100%;
          }
        }
      }
    }
    .custom-indicator{
      width: 90%;
      margin: 20px auto;
      text-align: center;
      color: #fff;
      span{
        display: inline-block;
        width: .6rem;
        height: .6rem;
        border: 1px solid #fff;
        border-radius: 50%;
        cursor: pointer;
        margin-left: 10px;
      }
      .active{
        background: #fff;
      }
    }
  }
}
.text-banner-m{
  width: 100%;
  background: url('@/assets/img/m-boke-bg.jpg');
  background-size: 100% 100%;
  padding-bottom: 130px;
  .items{
    width: 90vw;
    margin: auto;
    .item{
      height: 52px;
      padding: 10px 50px;
      background: url('@/assets/img/m-boke-item-bg.png') no-repeat;
      background-size: cover;
      margin-top: 8px;
      a{
        height: 35px;
        text-decoration: underline;
        font: 600 13px/15px Georgia-Bold;
        color: #333;
      }
    }
    & :first-child{
      margin-top: 0;
    }
  }
}
.video-big-list-banner-m{
  width: 100%;
  min-height: 530px;
  position: relative;
  & > img{
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    inset: 0;
  }
  .block{
    padding: 50px 0;
    position: relative;
    z-index: 1;
    .cover{
      width: 90%;
      margin: auto;
      position: relative;
      .play{
        display: inline-block;
        width: 60px;
        height: 60px;
        background: url('@/assets/img/icon-sh-play.png');
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        left: 10px;
        cursor: pointer;
      }
    }
    .info{
      width: 90%;
      margin: auto;
      margin-top: 20px;
      .title{
        font: 600 18px/0 Georgia-Bold;
        color: #333;
        text-decoration: underline;
        line-height: 2;
      }
      .abstract{
        color: #313030;
        font: 400 12px/20px Georgia-Bold;
        margin-top: 10px;
      }
    }
  }
}
.video-small-list-banner-m{
  width: 100%;
  height: 100%;
  position: relative;
  & > img{
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    inset: 0;
  }
  .block{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .item{
      width: 100%;
      position: relative;
      display: flex;
      .cover{
        width: 100%;
        flex-shrink: 0;
        & > img{
          width: 100%;
          display: block;
        }
        .play{
          position: absolute;
          bottom: 20px;
          left: 20px;
          width: 60px;
          height: 60px;
          background: url('@/assets/img/icon-sh-play.png');
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
      .title{
        color: #333;
        font: 600 13px/18px Georgia-Bold;
        width: 90px;
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        text-decoration: underline;
        word-wrap: break-word;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.dialog-video{
  height: 455px;
  margin-top: 50px;
}
.dialog-video-m{
  width: 90vw;
}

.share-title{
  color: #999;
  font-family: HelveticaLTPro-Light;
  font-size: 12px;
  font-weight: 400;
  line-height: 40px;
  text-align: center;
}
.share{
  display: flex;
  padding: 20px;
  gap: 10px;
  & > img{
    width: 40px;
    height: 40px;
    display: block;
    cursor: pointer;
  }
}
.qrcode{
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  margin-top: 120px;
  background: #fff;
  padding: 15px;
  .x{
    width: 5px;
    height: 5px;
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 20px;
    color: #333;
    cursor: pointer;
  }
  & > img{
    width: 100px;
    height: 100px;
  }
}
</style>
